export default "__VITE_ASSET__COdI75te__"